import React from 'react'
import { Hide, Box, Container } from 'pcln-design-system'
import { useContentful } from '@pcln/contentful-components'
import SmsOptIn from '@/components/SmsOptIn'
import PromoBanners from '@/components/MerchModuleWrapper/PromoBanners'
import AdBanner from '@/components/AdBanner'
import WhyPricelineBanner from '@/components/WhyPricelineBanner'
import WhyPricelineBannerExperiment from '@/components/WhyPricelineBanner/WhyPricelineBannerExperiment'
import PopularDestinations from '@/components/PopularDestinations'
import CreditCard from '@/components/CreditCard/CreditCard'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import BRANDED_MARKETING_CONTENT from '@/constants/promotions/branded-marketing'
import {
  EmailSignUpToast,
  EmailSignUpComponent
} from '@/components/EmailSignUp'
import PromoFeatureBox from '@/components/PromoFeatureBox'
import PackagesCarousel from '@/components/PackagesCarousel'
import RecentSearchCards from '@/components/RecentSearchCards'
import CrossSell from '@/components/CrossSell'
import useMostRecentFutureBooking from '@/hooks/useMostRecentFutureBooking'
import useExpressDealModal from '@/hooks/useExpressDealModal'
import ExpressDealModal from '@/components/Hotels/ExpressDeal/ExpressDealModal'
import MarketingTout from '@/components/Promos/MarketingTout/MarketingTout'
import useExtendStayBooking from '@/hooks/useExtendStayBooking'
import { REASONS_HOME, REASONS_HOME_EXPERIMENT } from '@/constants/reasons'
import ConditionalRender, {
  Experiment,
  Original
} from '@/components/ConditionalRender'
import ExtendStay from '@/components/ExtendStay'
import { CustomMerchModule, CustomToutType } from '@/types'
import { SilhouetteMarketingModule } from '@pcln/marketing'
import useSmsDisclaimerQueryArgs from '@/hooks/smsOptIn/useSmsDisclaimerQueryArgs'
import LayoutComponentWrapper from '@/components/LayoutComponentWrapper'
import AppDownloadOptIn from '../../AppDownloadOptIn/AppDownloadOptIn'

const expressDealQSKey = 'expressdeal'
const expressDealQSValue = 'y'

function AdBannerContent() {
  return (
    <AdBanner>
      <div id="div-gpt-ad-1614716188275-0" />
    </AdBanner>
  )
}

export default function HomeContent() {
  const mostRecentFutureBooking = useMostRecentFutureBooking()
  const extendData = useExtendStayBooking()
  const { isOpen } = useExpressDealModal(expressDealQSKey, expressDealQSValue)

  const smsDisclaimerQueryArgs = useSmsDisclaimerQueryArgs()

  const promoCollection: any = useContentful('promoCollection')
  const promoItems: CustomToutType[] | CustomMerchModule[] =
    promoCollection?.items || []

  return (
    <Container size="xl" mb={5}>
      <ExpressDealModal
        isModalOpen={isOpen}
        gaCategory={ANALYTICS_CATEGORY_HOME}
        qsKey={expressDealQSKey}
        qsValue={expressDealQSValue}
      />
      <ConditionalRender experimentCode="HP_HIGHER_XSELL">
        <Original>
          {!extendData && (
            <Box>
              <RecentSearchCards />
            </Box>
          )}
          <Hide md>
            {(extendData || mostRecentFutureBooking) && (
              <Box>
                {extendData ? (
                  <ExtendStay {...extendData} />
                ) : (
                  mostRecentFutureBooking && (
                    <CrossSell booking={mostRecentFutureBooking} />
                  )
                )}
              </Box>
            )}
            <PromoFeatureBox />
          </Hide>
        </Original>
        <Experiment>
          {!extendData && !mostRecentFutureBooking && (
            <Box>
              <RecentSearchCards />
            </Box>
          )}
          <Hide md>
            {(extendData || mostRecentFutureBooking) && (
              <Box>
                {extendData ? (
                  <ExtendStay {...extendData} />
                ) : (
                  mostRecentFutureBooking && (
                    <CrossSell booking={mostRecentFutureBooking} />
                  )
                )}
              </Box>
            )}
            <PromoFeatureBox />
          </Hide>
        </Experiment>
      </ConditionalRender>
      <AppDownloadOptIn />
      <ConditionalRender experimentCode="HP_SMS_COMPONENT">
        <Experiment>
          <SmsOptIn disclaimerQueryArgs={smsDisclaimerQueryArgs} />
        </Experiment>
      </ConditionalRender>
      <MarketingTout />
      <SilhouetteMarketingModule {...BRANDED_MARKETING_CONTENT} />
      <PackagesCarousel heading="Don't miss these hotel + flight deals" />
      <EmailSignUpComponent
        sourceId="LANDING_HOME"
        category={ANALYTICS_CATEGORY_HOME}
      />
      <LayoutComponentWrapper>
        <EmailSignUpToast sourceId="LANDING_HOME_TOAST_DESKTOP" />
      </LayoutComponentWrapper>
      <PopularDestinations />
      <PromoBanners merchModules={promoItems} />
      <CreditCard />
      <ConditionalRender experimentCode="HP_REFRESHED_WHY_PRICELINE">
        <Original>
          <Box>
            <WhyPricelineBanner content={REASONS_HOME} />
          </Box>
        </Original>
        <Experiment>
          <WhyPricelineBannerExperiment content={REASONS_HOME_EXPERIMENT} />
        </Experiment>
      </ConditionalRender>
      <AdBannerContent />
    </Container>
  )
}
